import { Link } from "react-router-dom";
import { PawPrint } from "lucide-react";

export function Footer({ onNavigate }) {
  const go = (e, href) => { e.preventDefault(); onNavigate(href); };
  return (
    <footer className="bg-[#0D3B3E] text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
                <PawPrint className="w-5 h-5 text-[#F7C948]" />
              </span>
              <span className="font-display font-extrabold text-xl tracking-tight">Dogtopia<span className="text-[#FF6B4A]">.</span></span>
            </div>
            <p className="text-white/60 text-sm max-w-xs leading-relaxed">
              North America's leading dog daycare, boarding, and spa franchise.
            </p>
          </div>
          <div className="flex gap-16">
            <div className="flex flex-col gap-3">
              <span className="text-xs uppercase tracking-[0.2em] text-white/50 font-semibold">Explore</span>
              {[["Why Dogtopia", "#benefits"], ["Economics", "#financials"], ["Process", "#process"], ["Owners", "#testimonials"]].map(([label, href]) => (
                <a key={href} href={href} onClick={(e) => go(e, href)} className="text-sm text-white/75 hover:text-white transition-colors">{label}</a>
              ))}
            </div>
            <div className="flex flex-col gap-3">
              <span className="text-xs uppercase tracking-[0.2em] text-white/50 font-semibold">Company</span>
              <a href="#lead-form" onClick={(e) => go(e, "#lead-form")} className="text-sm text-white/75 hover:text-white transition-colors">Request Info</a>
              <Link to="/admin/login" data-testid="footer-admin-link" className="text-sm text-white/75 hover:text-white transition-colors">Franchise Admin</Link>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/10 text-xs text-white/45 leading-relaxed max-w-4xl">
          This information is not intended as an offer to sell, or the solicitation of an offer to buy, a franchise. It is
          for information purposes only. Franchise offers are made only through a Franchise Disclosure Document (FDD).
          Demonstration recreation — figures shown are illustrative based on published 2026 FDD data.
        </div>
      </div>
    </footer>
  );
}
